import type { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material';

/**
 * Chip styles for a boolean pill that flags something needing immediate
 * action: a red outline and red text, so it stands out among the grey pills.
 *
 * @example
 * <Chip variant="outlined" sx={colouredPillSx('error', filter.value)} />
 */
export const colouredPillSx =
  (color: 'error', set: boolean): SxProps<Theme> =>
  (theme: Theme) => {
    const shade = theme.palette[color];
    const isLight = theme.palette.mode === 'light';
    return {
      // The darker shade reads better as text than main, like `Alert`.
      color: shade[isLight ? 'dark' : 'light'],
      borderColor: shade.main,
      bgcolor: set ? alpha(shade.main, 0.16) : 'background.paper',
      '& .MuiChip-icon': { color: 'inherit' },
      '&:hover': { bgcolor: alpha(shade.main, set ? 0.24 : 0.08) },
    };
  };
